var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-button",
    _vm._b(
      {
        class: { "reduced-padding-btn": _vm.$uiHelpers.isMobileOrTablet },
        attrs: { outline: "" },
        on: {
          click: function($event) {
            _vm.action ? _vm.action() : null
          }
        },
        nativeOn: {
          mouseover: function($event) {
            _vm.hover = true
          },
          mouseleave: function($event) {
            _vm.hover = false
          }
        }
      },
      "base-button",
      _vm.$attrs,
      false
    ),
    [
      _vm.reverse
        ? _c("span", { staticClass: "mr-2" }, [_vm._v(_vm._s(_vm.text))])
        : _vm._e(),
      _c("base-icon", {
        staticClass: "btn-icon",
        attrs: { color: _vm.$attrs.textColor, src: _vm.icon }
      }),
      !_vm.reverse && _vm.text
        ? _c("span", { staticClass: "ml-2" }, [_vm._v(_vm._s(_vm.text))])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3df269d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3df269d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/buttons/IconButton.vue
// module id = 1843
// module chunks = 117